import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import ru from './locales/ru.json';
import kk from './locales/kk.json';

export const SUPPORTED_LANGUAGES = [
  { code: 'ru', label: 'Русский' },
  { code: 'kk', label: 'Қазақша' },
];

// Разрешаем выбор "kk" или его региональные варианты (kk-KZ и т.п.).
export function normalizeLang(code?: string | null): string {
  const c = (code || '').toLowerCase().replace('_', '-');
  if (!c) return 'ru';
  const base = c.split('-')[0];
  return SUPPORTED_LANGUAGES.some(l => l.code === base) ? base : 'ru';
}

export function initI18n(initialLang: string = 'ru') {
  const lang = normalizeLang(initialLang);
  if (i18n.isInitialized) return i18n;
  void i18n.use(initReactI18next).init({
    resources: {
      ru: { translation: ru },
      kk: { translation: kk },
    },
    lng: lang,
    fallbackLng: 'ru',
    interpolation: { escapeValue: false },
    returnNull: false,
  });
  return i18n;
}

export default i18n;
